import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { CONVERSATIONS_SECTION } from 'app/constants/collaborator-section.constants';

@Injectable({ providedIn: 'root' })
export class CollaboratorAccessService implements CanActivate {
  canActivate(): Promise<boolean> {
    return this.ensureCollaboratorHasAccessOrRedirect(CONVERSATIONS_SECTION);
  }

  ensureCollaboratorHasAccessOrRedirect(
    sectionId?: number | string | null
  ): Promise<boolean> {
    const ensureCollaboratorHasAccessOrRedirect =
      window['ensureCollaboratorHasAccessOrRedirect'];

    if (typeof ensureCollaboratorHasAccessOrRedirect === 'function') {
      return Promise.resolve(ensureCollaboratorHasAccessOrRedirect(sectionId));
    }

    return new Promise(resolve => {
      setTimeout(() => {
        const retryEnsureCollaboratorHasAccessOrRedirect =
          window['ensureCollaboratorHasAccessOrRedirect'];

        if (typeof retryEnsureCollaboratorHasAccessOrRedirect === 'function') {
          resolve(retryEnsureCollaboratorHasAccessOrRedirect(sectionId));
          return;
        }

        resolve(true);
      }, 1000);
    });
  }
}
